import { render } from "./FrameProcessCreator.vue?vue&type=template&id=ce94a696&scoped=true"
import script from "./FrameProcessCreator.vue?vue&type=script&lang=js"
export * from "./FrameProcessCreator.vue?vue&type=script&lang=js"

import "./FrameProcessCreator.vue?vue&type=style&index=0&id=ce94a696&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce94a696"]])

export default __exports__